/* globals serverData */

import 'zoomforth_polyfills/polyfills_app_extended.js';

import zfrespond from 'zoomforth_zfrespond/legacy_respond_full.js';
import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

(function() {
  //// Setup app and defaults
  zfrespond.app.mediaCollector = new zfrespond.models.ExposedCollector(serverData.media_collector);
  zfrespond.app.fields = new zfrespond.models.ExposedFields(serverData.collector_fields,{
    mediaCollector: zfrespond.app.mediaCollector
  });
  zfrespond.app.contactCampaign = new zfrespond.models.ExposedContactCampaign(serverData.contact_campaign);
  zfrespond.app.loggedInUserMode = !!serverData.logged_in_user_email;

  var app = new zfrespond.views.RespondAppView({
    model: zfrespond.app.mediaCollector,
    fields: zfrespond.app.fields,
    campaign: zfrespond.app.contactCampaign,
    mobile: userAgentDetect.isMobile.isAnyRealDevice(),
    loggedInUserName: serverData.logged_in_user_name,
    loggedInUserEmail: serverData.logged_in_user_email,
    autoplay: serverData.autoplay
  });


  $(function() {
    
    if (userAgentDetect.isMobile.isAnyRealDevice()) {
      $('body').addClass('is-mobile');
    } else {
      $('body').addClass('is-desktop');
    }
    if (userAgentDetect.isMobile.Android()) {
      $('body').addClass('is-android');
    }
    $('body').append(app.$el);
    app.render();

    if(zfrespond.app.contactCampaign.get('id')) {
      zfrespond.app.contactCampaign.markPageVisited();
    }

  });


}());
